module.exports = __webpack_public_path__ + "img/MapPicsSwampPass.042f475f.webp";